import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputGroup } from './InputGroup.entity';

export class MutateProjectGroups<T extends EMode = EMode.entity> {
  /** Alias: structure */
  structure?: InputGroup<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<MutateProjectGroups> = {
  structure: {
    alias: 'structure',
  },
  __typename: {
    alias: '__typename',
  },
};

export const mutateProjectGroupsEntityDefinition: EntitiyDefinition<MutateProjectGroups> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'MutateProjectGroups',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
